<template>
  <div v-if="menuIsOpen" id="wrapper-lu-column-menu" class="mhv-100 h-100" :class="{'menu-collpased': collapsedMode}" v-click-outside="mutationIsOpen" :style="cssVars">
    <router-link to="/" class="logo text-center">
      <img :src="logoImgShowed" alt="" class="img-logo">
    </router-link>
    <ul id="menu-list" role="tablist">
        <li class="side-nav-title side-nav-item" @click="collapsedModeToggle">
          <font-awesome-icon
            :icon="collapseIcon"
            size="lg"
            class="icon-collapse ml-1"
            :title="$t('Navigation')"
          />
          <span v-if="!collapsedMode" class="ml-3">{{ $t('Navigation') }}</span>
        </li>
        <li v-for="(el, index) in menuItemsData" :key="index">
          <template v-if="el.parent">
            <b-btn v-b-toggle="el.id" variant="link" class="side-nav-link v-b-side-nav-link" @click="collapsedMode = false; $emit('expanded', true)">
              <i :class="el.icon" :title="el.name"></i>
              <span v-if="!collapsedMode"> {{ el.name }} </span>
              <i v-if="!collapsedMode" class="dripicons dripicons-chevron-right"></i>
              <i v-if="!collapsedMode" class="dripicons dripicons-chevron-down"></i>
            </b-btn>
            <b-collapse
              tag="ul"
              :id="el.id"
              accordion="accordion-app"
              role="tabpanel"
              class="side-nav-second-level"
              v-if="!collapsedMode"
              :visible="isVisible(el.childs)"
            >
              <li v-for="(child, index) in el.childs" :key="index">
                <router-link :to="child.path">
                  <i v-if="child.icon" :class="child.icon+' mr-2'" :title="child.name"></i>
                  <span>{{ child.name }}</span>
                </router-link>
              </li>
            </b-collapse>
          </template>
          <template v-else>
            <router-link :to="el.path" class="side-nav-link">
              <i :class="el.icon" :title="el.name"></i>
              <span v-if="!collapsedMode"> {{ el.name }} </span>
            </router-link>
          </template>
        </li>
    </ul>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

import { mapState, mapMutations, mapActions } from 'vuex'
import '@/directives/click-outside.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
library.add(faAngleDoubleLeft, faAngleDoubleRight)

export default {
  data () {
    return {
      collapsedMode: false,
      menuItemsData: []
    }
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('settings', ['logoImg', 'collapsedLogoImg', 'menuBgColor', 'menuFontColor', 'menuActiveFontColor', 'logoAlignItems', 'logoJustifyContent', 'logoWidth', 'logoPadding']),
    ...mapState('menu', ['menuIsOpen']),
    collapseIcon () {
      return this.collapsedMode ? 'angle-double-right' : 'angle-double-left'
    },
    logoImgShowed () {
      return this.collapsedMode ? this.collapsedLogoImg : this.logoImg
    },
    cssVars () {
      return {
        '--menu-bg-color': this.menuBgColor,
        '--menu-font-color': this.menuFontColor,
        '--active-menu-font-color': this.menuActiveFontColor,
        '--logo-align-items': this.logoAlignItems,
        '--logo-justify-content': this.logoJustifyContent,
        '--logo-width': this.logoWidth,
        '--logo-padding': this.logoPadding
      }
    }
  },
  methods: {
    ...mapMutations('menu', ['mutationIsOpen']),
    ...mapActions('menu', ['menuOnResize']),
    collapsedModeToggle () {
      this.collapsedMode = !this.collapsedMode
      this.$emit('expanded', !this.collapsedMode)
    },
    horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside () {
      this.menuItemsData = []
      this.menuItemsData = this.menuItems
    },
    isVisible (menuPath) {
      return menuPath.some(el => '/' + el?.path.split('/')[1] === this.$route.matched[1]?.path)
    }
  },
  directives: {
    ClickOutside
  },
  watch: {
    '$route.path' () {
      this.horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside()
    },
    menuItems () {
      this.horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside()
    }
  },
  mounted () {
    this.menuOnResize()
  }

}
</script>

<style lang="sass" scoped>
#wrapper-lu-column-menu
  background: var(--menu-bg-color)
  @media(max-width: $xl)
    position: fixed
    z-index: 10
  a,
  .side-nav-item
    color: var(--menu-font-color)
  button
    color: var(--menu-font-color)
    font-size: 15px
    &:hover
      color: white
      text-decoration: none
  .logo
    display: flex
    align-items: var(--logo-align-items)
    justify-content: var(--logo-justify-content)
    padding: var(--logo-padding)
  .img-logo
    width: var(--logo-width)
    height: auto
  #menu-list
    padding: 0
    button,
    a
      color: var(--menu-font-color)
      display: block
      position: relative
      width: 100%
      text-align: left
      &.router-link-active
        color: var(--active-menu-font-color)
      span
        font-size: 15px
    .dripicons-chevron-right
      display: none
    .dripicons-chevron-down
      display: inline-block
    .dripicons
      float: right
      margin: 0 !important
    .collapsed
      .dripicons-chevron-right
        display: inline-block
      .dripicons-chevron-down
        display: none
    .side-nav-title
      padding: 12px 30px
      letter-spacing: .05em
      cursor: default
      font-size: 13px
      text-transform: uppercase
      color: var(--menu-font-color)
      font-weight: 700
      cursor: pointer
    .side-nav-link
      padding: 15px 30px
      display: block
      i
        margin: 0 10px 0 3px
        line-height: 1.0625rem
        text-align: center
        vertical-align: middle
        width: 20px
      &:focus
        box-shadow: none
    .side-nav-second-level
      button,
      a
        font-size: 15px
        padding: 8px 20px 8px 68px
      .dripicons
        position: relative
        right: 13pxz
    .side-nav-third-level
      button,
      a
        padding: 8px 20px 8px 84px
  .icon-collapse
    cursor: pointer
  &.menu-collpased
    .logo
      img
        max-width: 70px
  .v-b-side-nav-link
    .dripicons
      position: relative
      top: 5
</style>
